'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseConfirmationModal = exports.PurchaseConfirmationModalUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ClassDetailCards = require('components/ClassDetailCards');

var _AppDownloads = require('components/AppDownloads');

var _multitrack = require('helpers/multitrack');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PurchaseConfirmationModalUnwrapped = exports.PurchaseConfirmationModalUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(PurchaseConfirmationModalUnwrapped, _PureComponent);

  function PurchaseConfirmationModalUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, PurchaseConfirmationModalUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = PurchaseConfirmationModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(PurchaseConfirmationModalUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleClick = function (device) {
      var schedule = _this.props.schedule;

      if (device === _AppDownloads.ANDROID) {
        (0, _multitrack.ga)('Membership Purchase', 'post-purchase-click-android-download', schedule.id, 0, { nonInteraction: true });
      } else if (device === _AppDownloads.IOS) {
        (0, _multitrack.ga)('Membership Purchase', 'post-purchase-click-ios-download', schedule.id, 0, { nonInteraction: true });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(PurchaseConfirmationModalUnwrapped, [{
    key: 'render',
    value: function render() {
      var schedule = this.props.schedule;
      var klass = schedule.class,
          venue = schedule.venue;
      var headerImage = venue.images.default,
          address = venue.address;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: 'modal__header__img', style: { backgroundImage: headerImage && 'url(' + headerImage + ')' } }),
        _react2.default.createElement(
          'div',
          { className: 'modal__body' },
          _react2.default.createElement(
            'div',
            { className: 'ph- md-ph text--left' },
            _react2.default.createElement(
              'h3',
              { className: 'text--bold mb' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'purchase-confirmation-modal.title',
                defaultMessage: 'You\u02BCre all set!'
              })
            ),
            _react2.default.createElement(_ClassDetailCards.CalendarCard, {
              address: address.address_line1,
              city: address.city,
              description: klass.description,
              endTime: schedule.endtime,
              klassName: klass.name,
              postalCode: address.zip_code,
              startTime: schedule.starttime,
              state: address.state,
              venueName: venue.name
            }),
            _react2.default.createElement(
              'div',
              { className: 'mt+' },
              _react2.default.createElement(_AppDownloads.AppDownloadIcons, {
                onClick: this.handleClick,
                extraClass: 'app-download-icons--light-gray'
              })
            )
          )
        )
      );
    }
  }]);
  return PurchaseConfirmationModalUnwrapped;
}(_react.PureComponent);

PurchaseConfirmationModalUnwrapped.propTypes = {
  schedule: _propTypes2.default.shape({
    endtime: _propTypes2.default.number.isRequired,
    class: _propTypes2.default.shape({
      description: _propTypes2.default.string,
      name: _propTypes2.default.string.isRequired
    }).isRequired,
    starttime: _propTypes2.default.number.isRequired,
    venue: _propTypes2.default.shape({
      address: _propTypes2.default.shape({
        address_line1: _propTypes2.default.string.isRequired,
        city: _propTypes2.default.string.isRequired,
        state: _propTypes2.default.string,
        zip_code: _propTypes2.default.string.isRequired
      }).isRequired,
      images: _propTypes2.default.shape({
        default: _propTypes2.default.string.isRequired
      }).isRequired,
      name: _propTypes2.default.string.isRequired,
      timezone: _propTypes2.default.string
    }).isRequired
  })
};

var PurchaseConfirmationModal = exports.PurchaseConfirmationModal = (0, _Modal2.default)({
  lightClose: true
})(PurchaseConfirmationModalUnwrapped);